import { jsx as _jsx } from "react/jsx-runtime";
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons';
import { useMultiStyleConfig } from '@companydotcom/potion';
import { FontAwesomeIcon } from '../font-awesome-icon';
export const CheckCircleIcon = (props) => {
    const styles = useMultiStyleConfig('Icons', props);
    return _jsx(FontAwesomeIcon, { icon: faCheckCircle, sx: styles.checkCircle }, void 0);
};
